import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { CartService, CartServiceModule } from '@b2b/common/services/cart';
import { TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope } from 'angular';

OrderContactDirective.$inject = ['$state', '$filter', 'AddressService', 'ApiService', 'HelpersService', 'CartService'];
function OrderContactDirective(
  $state: StateService,
  $filter: IFilterService,
  AddressService: AddressService,
  ApiService: TODO,
  HelpersService: TODO,
  CartService: CartService
) {
  OrderContactController.$inject = ['$scope', '$uibModal'];

  function OrderContactController($scope: IScope & { orderContact: TODO }, $uibModal: UIBModalService) {
    const ctrl = {
      model: {} as Partial<{ cardId: number }>,
      address: {},
      selectedCardholder: null,
      membersList: [],

      isLoaded: false,

      waitTime: 500,

      init: function () {
        $scope.$on('$destroy', $scope.$watch('orderContact.model', this.onModelUpdate));
      },

      searchMembers: function (searchText = '') {
        const props = HelpersService.getPaginator();

        if (!searchText && !this.isLoaded) {
          this.resetSelection();
          this.isLoaded = true;
        } else {
          props.search = searchText;
          props.pageSize = 8;
          ApiService.membership.summaries.search(props).then(this.success.searchMembers, this.error.searchMembers);
        }
      },

      isExpiredMembership: function () {
        // TODO Determine which cardholder to take
        if (this.model) {
          return CartService.memberships.isMembershipExpired(this.model.membership);
        }
        return false;
      },

      rejoin: function () {
        let props;

        if (this.model && this.model.membership) {
          props = {
            membershipId: this.model.membership.id,
            orderContactId: this.model.customerId,
          };
          if (props.membershipId) {
            $state.go('application.membership.retail', props);
            $scope.$emit('Cart::Close');
          }
        }
      },

      resetSelection: function (force = false) {
        if (force || this.model.cardId) {
          this.membersList = this.processMembersList([this.model]);
          this.selectedCardholder = this.membersList[0];
        } else {
          this.membersList = [];
          this.selectedCardholder = null;
        }
      },

      processMembersList: function (list) {
        //set name property

        if (!ctrl.isLoaded && !ctrl.membersList.length) {
          //show only the current orderContact
          list = list.filter(function (member) {
            let result = true;
            if (ctrl.model.cardId) {
              result = ctrl.model.cardId === member.id || ctrl.model.cardId === member.cardId;
            }
            return result;
          });
        } else {
          // don't show any members that have pending memberships
          list = list.filter(function (member) {
            return member.membershipStanding && member.membershipStanding !== 'new';
          });
        }
        angular.forEach(list, function (member) {
          if (!member.name) {
            member.name = HelpersService.getFullName(member);
          }
          if (!member.membership) {
            member.membership = {
              membershipExpirationDate: member.membershipExpirationDate,
              membershipStanding: member.membershipStanding,
              acmeMembershipNumber: member.acmeMembershipNumber,
              membershipCategory: member.membershipCategory,
            };
            member.membership = CartService.processMembership(member.membership);
          }
        });
        return list;
      },

      updateOrderContact: function () {
        const isNewMembership = CartService.memberships.hasNewMembership();
        const showPrompt =
          isNewMembership ||
          (CartService.hasOrderContact() && !CartService.isOrderContact(this.selectedCardholder.customerId));
        const isNewCardholder = this.model.cardId && this.model.cardId !== this.selectedCardholder.id;
        let message;
        let title = 'Are you sure?';

        if (showPrompt) {
          if (!this.selectedCardholder) {
            message =
              'Do you want to remove ' +
              HelpersService.getFullName(CartService.getOrderContact()) +
              ' from the order?' +
              '<br><br>Doing so will remove any items in the cart.';
          } else if (!this.selectedCardholder.customerId) {
            message =
              'Do you want to change the transacting member from ' +
              HelpersService.getFullName(CartService.getOrderContact()) +
              ' ?' +
              '<br><br>Doing so will remove any items in the cart.';
          } else {
            if (isNewMembership) {
              title = 'Proceeding will clear the cart';
              message =
                HelpersService.getFullName(this.selectedCardholder) +
                ' already has a membership: ' +
                this.selectedCardholder.membershipCategory +
                ' (expiring ' +
                $filter('date')(this.selectedCardholder.cardExpirationDate, HelpersService.dateFormats.shortDate) +
                ').' +
                ' Adding a member to this cart will clear the contents.';
            } else {
              message =
                'Do you want to transact as ' +
                HelpersService.getFullName(this.selectedCardholder) +
                ' instead of ' +
                HelpersService.getFullName(CartService.getOrderContact()) +
                '? ' +
                '<br><br>Doing so will remove any items in the cart.';
            }
          }

          this.showMessage(
            title,
            message,
            'Continue',
            function (response) {
              ctrl.updateContactAndProceed(isNewMembership);
            },
            function () {
              if (ctrl.model) {
                ctrl.selectedCardholder = HelpersService.getFullName(ctrl.model);
              } else if (!ctrl.selectedCardholder) {
                ctrl.resetSelection();
              }
            }
          );
        } else if (isNewCardholder) {
          //same customer but different membership
          message =
            'Do you want to transact as ' +
            this.selectedCardholder.membershipCategory +
            ' instead of ' +
            CartService.getTransactingMembership().membershipCategory +
            '?' +
            '<br><br>Doing so will remove any items in the cart.';

          this.showMessage(
            'Are you sure?',
            message,
            'Continue',
            function (response) {
              ctrl.updateContactAndProceed();
            },
            function () {
              if (ctrl.model) {
                ctrl.selectedCardholder = HelpersService.getFullName(ctrl.model);
              } else if (!ctrl.selectedCardholder) {
                ctrl.resetSelection();
              }
            }
          );
        } else {
          this.updateContactAndProceed();
        }
      },

      updateContactAndProceed: function (clearCart = false) {
        let contact;

        if (this.selectedCardholder) {
          contact = {
            membershipId: this.selectedCardholder.membershipId,
            cardholders: this.selectedCardholder.customerId ? [this.selectedCardholder] : null,
            orderContactId: this.selectedCardholder.customerId,
          };
        } else {
          contact = null;
        }

        if (clearCart) {
          //clear the cart and then update the order contact
          CartService.cancelCart().then(function (cartResponse) {
            CartService.memberships
              .updateOrderContact(contact)
              .then(ctrl.success.updateOrderContact, ctrl.error.updateOrderContact);
          }, ctrl.error.updateOrderContact);
        } else {
          CartService.memberships
            .updateOrderContact(contact)
            .then(this.success.updateOrderContact, this.error.updateOrderContact);
        }
      },

      showMessage: function (title, message, okText, successCallback, errorCallback) {
        if (message) {
          const showMessageModal = $uibModal.open({
            size: 'md',
            controller: 'ConfirmModalController',
            templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
            resolve: {
              modalTitle: function () {
                return title;
              },
              modalMessage: function () {
                return message;
              },
              okText: function () {
                return okText || 'Done';
              },
              cancelText: function () {
                return null;
              },
            },
          });
          // Invoked when modal completes with close(params)
          showMessageModal.result.then(
            function () {
              if (typeof successCallback === 'function') {
                successCallback();
              }
            },
            function () {
              // Do nothing
              if (typeof errorCallback === 'function') {
                errorCallback();
              }
            }
          );
        }
      },

      success: {
        searchMembers: function (response) {
          ctrl.membersList = ctrl.processMembersList(response.data.payload.list);
          if (!ctrl.isLoaded) {
            ctrl.selectedCardholder = ctrl.membersList[0];
          }
          $scope.$broadcast('CustomTypeahead::FilterResults', {
            field: 'combobox-input-' + 'order-contact-membership-search',
          });

          ctrl.isLoaded = true;
        },

        updateOrderContact: function (response) {
          if (!ctrl.selectedCardholder) {
            ctrl.resetSelection(true);
          }
          //Refresh the cart so that items are updated
          $scope.$emit('Cart::Refresh');
        },

        updateOrderContactAndClearCart: function (response) {
          //clear the cart and then update the order contact
          CartService.cancelCart().then(function (cartResponse) {
            ctrl.success.updateOrderContact(response);
          }, ctrl.error.updateOrderContact);
        },
      },

      error: {
        searchMembers: function () {
          ctrl.membersList = [];
          ctrl.isLoaded = true;
        },

        updateOrderContact: function (response) {
          if (!ctrl.selectedCardholder) {
            ctrl.resetSelection();
          }
        },
      },

      onCardholderChange: function (e, data) {
        ctrl.updateOrderContact();
      },

      onBlur: function () {
        ctrl.resetSelection();
      },

      onModelUpdate: function (n, o) {
        if (HelpersService.isEmptyObject(n)) {
          ctrl.selectedCardholder = null;
        } else {
          ctrl.selectedCardholder = HelpersService.getFullName(n);
        }
        if (!ctrl.membersList.length) {
          ctrl.searchMembers();
        }
      },
    };

    $scope.orderContact = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    require: 'ngModel',
    templateUrl: 'common/directives/order/contact/contact.tpl.html',

    link: function ($scope, $element, $attrs, ngModelCtrl) {
      // Modified after controller runs
      ngModelCtrl.$formatters.push(function (modelValue) {
        return modelValue ? { model: modelValue || {} } : { model: {} };
      });

      ngModelCtrl.$render = function () {
        $scope.orderContact.model = ngModelCtrl.$viewValue.model;
        if (!HelpersService.isEmptyObject($scope.orderContact.model)) {
          $scope.orderContact.model.address = AddressService.createAddress(ngModelCtrl.$viewValue.model);
        }
      };
    },

    controller: OrderContactController,
  };
}

export const OrderContactDirectiveModule = angular
  .module('acme.common.directive.order.contact', [
    AddressServiceModule,
    'acme.common.service.api',
    'acme.common.service.helpers',
    CartServiceModule,
    'acme.common.directive.contactSearch',
    'ui.bootstrap',
  ])
  .directive('orderContact', OrderContactDirective).name;
